<div class="app-expansion-panel-trigger-container">
  <app-expansion-panel-button [(expanded)]="expanded" />
</div>
<div class="app-expansion-panel-content">
  <ng-content />
</div>
